import { render, staticRenderFns } from "./ErrorsDiv.vue?vue&type=template&id=ef72529e&scoped=true"
import script from "./ErrorsDiv.vue?vue&type=script&lang=js"
export * from "./ErrorsDiv.vue?vue&type=script&lang=js"
import style0 from "./ErrorsDiv.vue?vue&type=style&index=0&id=ef72529e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef72529e",
  null
  
)

export default component.exports